import React from 'react';
import { Typography, Grid, Box } from '@mui/material';
import calendarIcon from '../../assets/calendar.png';
import eventIcon from '../../assets/event.png';
import pencilIcon from '../../assets/pencil.png';
import familyIcon from '../../assets/family.png';
import { EventDetail } from '../../types';
import { formatDate } from '../../utils';

interface EventKeyInformationProps {
    event: EventDetail;
}

const EventKeyInformation: React.FC<EventKeyInformationProps> = ({ event }) => {
    return (
        <>
            <Typography variant="h6" gutterBottom pt={2} pb={2}>
                Key Information
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Box display="flex" alignItems="center" mb={2}>
                        <img src={calendarIcon} alt="Calendar" style={{ width: '30px', height: '30px', marginRight: '15px' }} />
                        <Box>
                            <Typography variant="body1" className='fw-700'>Event Dates</Typography>
                            <Typography variant="body2">{`${formatDate(event.startDate)} - ${formatDate(event.endDate)}`}</Typography>
                        </Box>
                    </Box>
                </Grid>
                {event.isRecurring != 0 && event.nextStartDate && new Date(event.nextStartDate) >= new Date() && (
                    <Grid item xs={12} sm={4}>
                        <Box display="flex" alignItems="center" mb={2}>
                            <img src={eventIcon} alt="Event" style={{ width: '30px', height: '30px', marginRight: '15px' }} />
                        <Box>
                                <Typography variant="body1" className='fw-700'>Next Available Start Date</Typography>
                                <Typography variant="body2">{formatDate(event.nextStartDate) ?? 'N/A'}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                )}
                <Grid item xs={12} sm={4}>
                    <Box display="flex" alignItems="center" mb={2}>
                        <img src={pencilIcon} alt="Pencil" style={{ width: '30px', height: '30px', marginRight: '15px' }} />
                        <Box>
                            <Typography variant="body1" className='fw-700'>Registration Dates</Typography>
                            <Typography variant="body2">{`${formatDate(event.registrationStartDate)} - ${formatDate(event.registrationEndDate)}`}</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Box display="flex" alignItems="center" mb={2}>
                        <img src={familyIcon} alt="Family" style={{ width: '30px', height: '30px', marginRight: '15px' }} />
                        <Box>
                            <Typography variant="body1" className='fw-700'>Age Range</Typography>
                            <Typography variant="body2">{`Must Be ${Math.floor(event.minMonthsRestrictions / 12)} year(s) ${event.minMonthsRestrictions % 12} month(s) by  ${formatDate(event.startDate)} to attend`}</Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

export default EventKeyInformation;